import React, { useRef } from "react";
import { useCalendarState } from "react-stately";
import { useCalendar, useLocale } from "react-aria";
import { createCalendar } from "@internationalized/date";
import { CalendarButton } from "./Button";
import { CalendarGrid } from "./CalendarGrid";
import styled from "styled-components";

export function Calendar(props) {
  const { locale, direction } = useLocale();
  const state = useCalendarState({ ...props, locale, createCalendar });

  const ref = useRef();
  const { calendarProps, prevButtonProps, nextButtonProps, title } =
    useCalendar(props, state, ref);

  return (
    <Wrapper
      {...calendarProps}
      ref={ref}
      locale={locale}
      dir={direction}
      {...props}
    >
      <Container>
        <CalendarButton {...prevButtonProps}>
          <Arrow>&lt;</Arrow>
        </CalendarButton>
        <Heading>{title}</Heading>
        <CalendarButton {...nextButtonProps}>
          <Arrow>&gt;</Arrow>
        </CalendarButton>
      </Container>
      <CalendarGrid state={state} />
    </Wrapper>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 4px;
`;

const Heading = styled.h2`
  flex: 1;
  text-align: center;
  font-size: 1.25rem;
`;

const Wrapper = styled.div`
  text-align: center;
  font-size: 1rem;
  width: fit-content;
  font-family: "Assistant";
`;

const Arrow = styled.span`
  font-family: "Poppins";
  font-weight: 300;
  font-size: 25px;
`;
